/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


// May contain unused imports in some cases
// @ts-ignore
import { CardTransactionEvidenceCreatedBy } from './card-transaction-evidence-created-by';
// May contain unused imports in some cases
// @ts-ignore
import { CardTransactionEvidenceErrors } from './card-transaction-evidence-errors';
// May contain unused imports in some cases
// @ts-ignore
import { CardTransactionEvidenceInvoiceIssuer } from './card-transaction-evidence-invoice-issuer';
// May contain unused imports in some cases
// @ts-ignore
import { CardTransactionEvidenceUpdatedBy } from './card-transaction-evidence-updated-by';
// May contain unused imports in some cases
// @ts-ignore
import { CardTransactionEvidenceUploadedBy } from './card-transaction-evidence-uploaded-by';
// May contain unused imports in some cases
// @ts-ignore
import { CardTransactionEvidenceWarnings } from './card-transaction-evidence-warnings';

/**
 * 
 * @export
 * @interface CardTransactionEvidence
 */
export interface CardTransactionEvidence {
    /**
     * 
     * @type {string}
     * @memberof CardTransactionEvidence
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof CardTransactionEvidence
     * @deprecated
     */
    'cardTransactionEvidenceId': string;
    /**
     * 
     * @type {string}
     * @memberof CardTransactionEvidence
     */
    'paymentReferenceId': string;
    /**
     * 
     * @type {string}
     * @memberof CardTransactionEvidence
     * @deprecated
     */
    'visaTransactionReferenceId': string;
    /**
     * 
     * @type {string}
     * @memberof CardTransactionEvidence
     */
    'paymentType': CardTransactionEvidencePaymentTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof CardTransactionEvidence
     */
    'fileName': string;
    /**
     * 
     * @type {string}
     * @memberof CardTransactionEvidence
     */
    'fileExtension': string;
    /**
     * 
     * @type {string}
     * @memberof CardTransactionEvidence
     */
    'electronicMethod': CardTransactionEvidenceElectronicMethodEnum;
    /**
     * 
     * @type {string}
     * @memberof CardTransactionEvidence
     */
    'documentSize': CardTransactionEvidenceDocumentSizeEnum;
    /**
     * 
     * @type {number}
     * @memberof CardTransactionEvidence
     * @deprecated
     */
    'dpi': number | null;
    /**
     * 
     * @type {number}
     * @memberof CardTransactionEvidence
     */
    'detectedDpi': number | null;
    /**
     * 
     * @type {number}
     * @memberof CardTransactionEvidence
     */
    'calculatedDpi': number | null;
    /**
     * 
     * @type {number}
     * @memberof CardTransactionEvidence
     */
    'colorGradation': number | null;
    /**
     * 
     * @type {number}
     * @memberof CardTransactionEvidence
     */
    'verticalPixels': number | null;
    /**
     * 
     * @type {number}
     * @memberof CardTransactionEvidence
     */
    'horizontalPixels': number | null;
    /**
     * 
     * @type {number}
     * @memberof CardTransactionEvidence
     */
    'heightMillis': number | null;
    /**
     * 
     * @type {number}
     * @memberof CardTransactionEvidence
     */
    'widthMillis': number | null;
    /**
     * 
     * @type {string}
     * @memberof CardTransactionEvidence
     */
    'legalValidity': CardTransactionEvidenceLegalValidityEnum;
    /**
     * 
     * @type {boolean}
     * @memberof CardTransactionEvidence
     */
    'dpiForciblyValid': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CardTransactionEvidence
     */
    'colorGradationForciblyValid': boolean;
    /**
     * 
     * @type {string}
     * @memberof CardTransactionEvidence
     */
    'note': string;
    /**
     * 
     * @type {boolean}
     * @memberof CardTransactionEvidence
     */
    'irrelevantToLedger': boolean;
    /**
     * 
     * @type {CardTransactionEvidenceInvoiceIssuer}
     * @memberof CardTransactionEvidence
     */
    'invoiceIssuer': CardTransactionEvidenceInvoiceIssuer | null;
    /**
     * 
     * @type {string}
     * @memberof CardTransactionEvidence
     * @deprecated
     */
    'dpiError': CardTransactionEvidenceDpiErrorEnum;
    /**
     * 
     * @type {string}
     * @memberof CardTransactionEvidence
     * @deprecated
     */
    'detectedDpiError': CardTransactionEvidenceDetectedDpiErrorEnum;
    /**
     * 
     * @type {string}
     * @memberof CardTransactionEvidence
     * @deprecated
     */
    'calculatedDpiError': CardTransactionEvidenceCalculatedDpiErrorEnum;
    /**
     * 
     * @type {string}
     * @memberof CardTransactionEvidence
     * @deprecated
     */
    'colorGradationError': CardTransactionEvidenceColorGradationErrorEnum;
    /**
     * 
     * @type {string}
     * @memberof CardTransactionEvidence
     * @deprecated
     */
    'heightMillisError': CardTransactionEvidenceHeightMillisErrorEnum;
    /**
     * 
     * @type {string}
     * @memberof CardTransactionEvidence
     * @deprecated
     */
    'widthMillisError': CardTransactionEvidenceWidthMillisErrorEnum;
    /**
     * 
     * @type {CardTransactionEvidenceErrors}
     * @memberof CardTransactionEvidence
     */
    'errors': CardTransactionEvidenceErrors;
    /**
     * 
     * @type {CardTransactionEvidenceWarnings}
     * @memberof CardTransactionEvidence
     */
    'warnings': CardTransactionEvidenceWarnings;
    /**
     * 
     * @type {CardTransactionEvidenceCreatedBy}
     * @memberof CardTransactionEvidence
     */
    'createdBy': CardTransactionEvidenceCreatedBy;
    /**
     * 
     * @type {CardTransactionEvidenceUpdatedBy}
     * @memberof CardTransactionEvidence
     */
    'updatedBy': CardTransactionEvidenceUpdatedBy;
    /**
     * 
     * @type {string}
     * @memberof CardTransactionEvidence
     */
    'updatedAt': string;
    /**
     * 
     * @type {CardTransactionEvidenceUploadedBy}
     * @memberof CardTransactionEvidence
     */
    'uploadedBy': CardTransactionEvidenceUploadedBy;
    /**
     * 
     * @type {string}
     * @memberof CardTransactionEvidence
     */
    'uploadedAt': string;
    /**
     * 
     * @type {boolean}
     * @memberof CardTransactionEvidence
     */
    'uploadedByRecipient': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CardTransactionEvidence
     */
    'needsMigration': boolean | null;
    /**
     * 
     * @type {string}
     * @memberof CardTransactionEvidence
     */
    'uploadedFrom': string;
}

export const CardTransactionEvidencePaymentTypeEnum = {
    cardTransaction: 'CARD_TRANSACTION',
    paymentRequest: 'PAYMENT_REQUEST'
} as const;

export type CardTransactionEvidencePaymentTypeEnum = typeof CardTransactionEvidencePaymentTypeEnum[keyof typeof CardTransactionEvidencePaymentTypeEnum];
export const CardTransactionEvidenceElectronicMethodEnum = {
    fullElectronic: 'FULL_ELECTRONIC',
    originallyPaper: 'ORIGINALLY_PAPER',
    unknown: 'UNKNOWN'
} as const;

export type CardTransactionEvidenceElectronicMethodEnum = typeof CardTransactionEvidenceElectronicMethodEnum[keyof typeof CardTransactionEvidenceElectronicMethodEnum];
export const CardTransactionEvidenceDocumentSizeEnum = {
    overA4: 'OVER_A4',
    a4OrSmaller: 'A4_OR_SMALLER',
    unknown: 'UNKNOWN'
} as const;

export type CardTransactionEvidenceDocumentSizeEnum = typeof CardTransactionEvidenceDocumentSizeEnum[keyof typeof CardTransactionEvidenceDocumentSizeEnum];
export const CardTransactionEvidenceLegalValidityEnum = {
    valid: 'VALID',
    invalid: 'INVALID',
    inputRequired: 'INPUT_REQUIRED',
    outOfTarget: 'OUT_OF_TARGET'
} as const;

export type CardTransactionEvidenceLegalValidityEnum = typeof CardTransactionEvidenceLegalValidityEnum[keyof typeof CardTransactionEvidenceLegalValidityEnum];
export const CardTransactionEvidenceDpiErrorEnum = {
    pixelsInsufficient: 'PIXELS_INSUFFICIENT',
    pixelsRequired: 'PIXELS_REQUIRED',
    realSizeRequired: 'REAL_SIZE_REQUIRED',
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type CardTransactionEvidenceDpiErrorEnum = typeof CardTransactionEvidenceDpiErrorEnum[keyof typeof CardTransactionEvidenceDpiErrorEnum];
export const CardTransactionEvidenceDetectedDpiErrorEnum = {
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type CardTransactionEvidenceDetectedDpiErrorEnum = typeof CardTransactionEvidenceDetectedDpiErrorEnum[keyof typeof CardTransactionEvidenceDetectedDpiErrorEnum];
export const CardTransactionEvidenceCalculatedDpiErrorEnum = {
    pixelsInsufficient: 'PIXELS_INSUFFICIENT',
    pixelsRequired: 'PIXELS_REQUIRED',
    realSizeRequired: 'REAL_SIZE_REQUIRED',
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type CardTransactionEvidenceCalculatedDpiErrorEnum = typeof CardTransactionEvidenceCalculatedDpiErrorEnum[keyof typeof CardTransactionEvidenceCalculatedDpiErrorEnum];
export const CardTransactionEvidenceColorGradationErrorEnum = {
    required: 'REQUIRED',
    insufficient: 'INSUFFICIENT'
} as const;

export type CardTransactionEvidenceColorGradationErrorEnum = typeof CardTransactionEvidenceColorGradationErrorEnum[keyof typeof CardTransactionEvidenceColorGradationErrorEnum];
export const CardTransactionEvidenceHeightMillisErrorEnum = {
    required: 'REQUIRED'
} as const;

export type CardTransactionEvidenceHeightMillisErrorEnum = typeof CardTransactionEvidenceHeightMillisErrorEnum[keyof typeof CardTransactionEvidenceHeightMillisErrorEnum];
export const CardTransactionEvidenceWidthMillisErrorEnum = {
    required: 'REQUIRED'
} as const;

export type CardTransactionEvidenceWidthMillisErrorEnum = typeof CardTransactionEvidenceWidthMillisErrorEnum[keyof typeof CardTransactionEvidenceWidthMillisErrorEnum];


